// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-80{width:80%}.resolution{width:300px;height:auto}.ml-75{margin-left:75%}.button-modal{width:10%;height:5%}.button-modal-sm{width:20%;height:5%}.btn-width{width:57px;font-size:12px}.delete-btn-width{width:69px;font-size:12px}.add-service-button{position:fixed;bottom:4%;right:44px;width:50px;height:50px;border-radius:50%;z-index:1031;font-size:24px;font-weight:700;padding:0}textarea{resize:none}", ""]);
// Exports
module.exports = exports;
